import TheCheckoutStepOne from "@/TheCheckout/TheCheckoutStepOne";
import TheCheckoutStepTwo from "@/TheCheckout/TheCheckoutStepTwo";
import TheCheckoutStepThree from "@/TheCheckout/TheCheckoutStepThree";
import TheCheckoutStepFour from "@/TheCheckout/TheCheckoutStepFour";

export const baseRoutes = [
    {
        path: "/online-payment",
        name: "OnlinePayment",
        component: () => import(/* webpackChunkName: "O_Pmnt" */ "@/pages/OnlinePayment"),
    },
    {
        path: "/online-payment/:orderId",
        name: "OnlinePaymentId",
        component: () => import(/* webpackChunkName: "O_Pmnt" */ "@/pages/OnlinePayment"),
        props: (route) => ({
            orderId: route.params.orderId,
        }),
    },
    {
        path: "/status",
        name: "Status",
        component: () => import(/* webpackChunkName: "Stts" */ "@/pages/Status"),
    },
    {
        path: "/status/:id",
        name: "StatusId",
        component: () => import(/* webpackChunkName: "Stts" */ "@/pages/Status"),
    },
    {
        path: "/order",
        name: "Order",
        component: () => import(/* webpackChunkName: "Ordr" */ "@/TheCheckout/index"),
        children: [
            {
                name: "TheCheckoutStepOne",
                path: "",
                component: TheCheckoutStepOne,
                props: {
                    routerStep: 0,
                },
            },
            {
                name: "TheCheckoutStepTwo",
                path: "2",
                component: TheCheckoutStepTwo,
                props: {
                    routerStep: 1,
                },
            },
            {
                name: "TheCheckoutStepThree",
                path: "3",
                component: TheCheckoutStepThree,
                props: {
                    routerStep: 2,
                },
            },
            {
                name: "TheCheckoutStepFour",
                path: "4",
                component: TheCheckoutStepFour,
                props: {
                    routerStep: 3,
                },
            },
        ],
    },
    {
        path: "*",
        redirect: "/404",
    },
];

if (!["madrobots"].includes(process.env.VUE_APP_NAME_SITE)) {
    baseRoutes.push({
        path: "/404",
        name: "ErrorPage",
        component: () => import(/* webpackChunkName: "404" */ "@/pages/404"),
    });
}
